import {routerConfig} from "./RouterConfig";

import Common from "./common";
import ClientDashboard from "./client";
import OmsDashboard from "./oms";

const rootDir = "app/dashboard";

export default angular.module("tfApp.dashboard", [Common(), ClientDashboard(rootDir), OmsDashboard()])
                      .config(routerConfig)
                      .name;
